import { takeLatest, call, put } from 'redux-saga/effects';
import fetchEntity from 'reducers/utils/fetchEntitySaga';
import createFetchTypes from 'reducers/utils/createFetchTypes';
import ApiClient from 'Services/ApiClient';
import { showAlertAction } from 'reducers/popUps/alertPopUpReducer';

import { showLoader, hideLoader } from 'reducers/popUps/loaderReducer';

const FETCH_AUDITLOGS = createFetchTypes(
  'Marketplace/Adminstration/auditLog/FETCH_AUDITLOG'
);

const FETCH_URL = 'reports/auditlog';

function auditLog(state = { data: { pagedCollection: [] } }, action = {}) {
  switch (action.type) {
    case FETCH_AUDITLOGS.REQUEST:
      return {
        ...state,
        loading: true
      };
    case FETCH_AUDITLOGS.SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data
      };
    case FETCH_AUDITLOGS.ERROR:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}

export const fetchAuditLog = {
  base: params => ({
    type: FETCH_AUDITLOGS.BASE,
    params,
    url: FETCH_URL
  }),
  request: () => ({ type: FETCH_AUDITLOGS.REQUEST }),
  success: data => ({ type: FETCH_AUDITLOGS.SUCCESS, data }),
  failure: error => ({ type: FETCH_AUDITLOGS.FAILURE, error })
};

export function* fetchAuditLogSaga({ url, params }) {
  yield put(showLoader());
  try {
    yield call(() => fetchEntity(fetchAuditLog, ApiClient.httpClient.post, url, params));
  } catch (error) {
    yield put(showAlertAction(error.response.data));
  }
  yield put(hideLoader());
}

export default auditLog;

export function* auditLogMiddleware() {
  yield takeLatest(FETCH_AUDITLOGS.BASE, fetchAuditLogSaga);
}
